/**
 * @generated SignedSource<<4d7ccfc95dff4e3b611db90e9453df55>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9

import type { ConcreteRequest } from 'relay-runtime';
export type usePendingRequestExistsQuery$variables = {
  accessRequestedAaid: string;
  cloudId: string;
  contentId: string;
};
export type usePendingRequestExistsQuery$data = {
  readonly confluence_pendingRequestExists: {
    readonly isPendingAccessRequestExists: boolean | null;
  } | null;
};
export type usePendingRequestExistsQuery = {
  response: usePendingRequestExistsQuery$data;
  variables: usePendingRequestExistsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessRequestedAaid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accessRequestedAaid",
        "variableName": "accessRequestedAaid"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ConfluencePendingAccessRequest",
    "kind": "LinkedField",
    "name": "confluence_pendingRequestExists",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isPendingAccessRequestExists"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePendingRequestExistsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePendingRequestExistsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f8787096f4d42896880d52d9cbd4670c",
    "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
    "metadata": {},
    "name": "usePendingRequestExistsQuery",
    "operationKind": "query",
    "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
  }
};
})();

(node as any).hash = "4d877c3ca505e954e3d6f173f1138ce0";

export default node;
